import SimpleBanner from "../components/landing/SimpleBanner";
import Privacy from "../components/landing/Privacy";

const PrivacyPolicy = () => {
    return (
        <>
            <SimpleBanner title="Privacy Policy" />
            <Privacy />
        </>
    );
};

export default PrivacyPolicy;
